import React, { useEffect, useState } from 'react';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { Fetch } from '../../shared/Fetch';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { JVInput } from '../../shared/JVInput';
import { JVCheckbox } from '../../shared/JVCheckbox';

interface IProps {
    singleData: ISpecialClauseMast,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

export interface ISpecialClauseMast {
    id?: number,
    special_Clause: string,
    status: boolean
}

export const EmptySpecialClauseMast: ISpecialClauseMast = {
    special_Clause: "",
    status: true
}

const schema = yup.object().shape({
    special_Clause: yup.string().required('Special Clause required'),
    status: yup.boolean().required('Status is required')
})

export const Form = (props: IProps) => {
    const [loading, setLoading] = useState<boolean>(false);
    const { control, handleSubmit, formState: { errors }, reset } = useForm<ISpecialClauseMast>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData || EmptySpecialClauseMast,
        shouldFocusError: false
    });

    useEffect(() => {
        reset(props.singleData);
    }, [props.open]);

    const onSubmit = async (data: ISpecialClauseMast) => {
        setLoading(true);
        const method = props.singleData?.id ? "PUT" : "POST";
        const message = props.singleData?.id ? "Updated Successfully" : "Added Successfully";
        const response = await Fetch("Special_Clause_Mast", method, data, null, props.toast)
        if (response) {
            props.hideDialog();
            props.setReload(!props.reload);
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
        }
        setLoading(false);
    }

    const onHide = () => {
        props.hideDialog();
        reset(EmptySpecialClauseMast);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Special Clause Mast " modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput required label='Special Clause' name='special_Clause' control={control} error={errors.special_Clause?.message} />
                <JVCheckbox required label='Status' name='status' control={control} error={errors.status?.message} />
                <div className="col-12 md:col-12 flex gap-4">
                    <Button className="field col md:col" label="SAVE" type="submit" loading={loading}></Button>
                    <Button className="field col md:col p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    )
}
